module.exports = __webpack_public_path__ + "img/121.e4495a42.svg";